import { CONSTANTS } from '../Helpers/Configuration';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import last from 'lodash/last';
import every from 'lodash/every';
import { getEmptyQuestion } from './TemplateHelpers';
import { v4 as uuidv4 } from 'uuid';

const handleContractQuestion = (state, question, position) => {
    state.applicationQuestions.splice(
        position, 1,
        question, getEmptyQuestion(question.pageId, question.sectionId, question.groupId)
    );

    state.applicationQuestions = [...state.applicationQuestions];
};

const handleExpandQuestion = (state, question, position) => {
    const { controlTypes } = CONSTANTS;
    const beforeQuestionsInGroup = [];
    const afterQuestionsInGroup = [];
    const groupIndex = findIndex(state.applicationGroups, g => g.id == question.groupId);
    const group = state.applicationGroups[groupIndex];
    const newQuestionOrder = [];
    const newGroupOrder = [];

    //TODO: can we break after we move on from this question's group?
    state.applicationQuestions.forEach((q, i) => {
        if (q.groupId == question.groupId) {
            if (position > i) {
                beforeQuestionsInGroup.push(q);
            }
            else if (position < i) {
                afterQuestionsInGroup.push(q);
            }
        }
    });

    if (beforeQuestionsInGroup.length) {
        const beforeGroup = cloneDeep(group);
        beforeGroup.id = uuidv4();
        newGroupOrder.push(beforeGroup);

        beforeQuestionsInGroup.forEach(q => {
            q.groupId = beforeGroup.id;
            newQuestionOrder.push(q);
        });

        newQuestionOrder.push(getEmptyQuestion(question.pageId, question.sectionId, beforeGroup.id));
    }

    newGroupOrder.push(group);
    newQuestionOrder.push(question);

    // If there is only an empty question after the expanded field, don't make a new group.
    if (afterQuestionsInGroup.length && !every(afterQuestionsInGroup, q => q.type == controlTypes.empty)) {
        const afterGroup = cloneDeep(group);
        afterGroup.id = uuidv4();
        newGroupOrder.push(afterGroup);

        afterQuestionsInGroup.forEach(q => {
            q.groupId = afterGroup.id;
            newQuestionOrder.push(q);
        });

        // Last question in this group may already be empty.
        if (last(afterQuestionsInGroup)?.type != controlTypes.empty) {
            newQuestionOrder.push(getEmptyQuestion(question.pageId, question.sectionId, afterGroup.id));
        }
    }

    if (newGroupOrder.length > 1) {
        state.applicationGroups.splice(groupIndex, 1, ...newGroupOrder);
        state.applicationGroups = [...state.applicationGroups];
    }

    // If there were any other questions in the group, we have to re-splice
    if (beforeQuestionsInGroup.length || afterQuestionsInGroup.length) {
        state.applicationQuestions.splice(
            position - beforeQuestionsInGroup.length,
            beforeQuestionsInGroup.length + afterQuestionsInGroup.length + 1,
            ...newQuestionOrder
        );
        state.applicationQuestions = [...state.applicationQuestions];
    }
};

export const setFieldPropertyForPage = (state, action) => {
    const payload = action.payload;
    const position = payload?.position;
    const property = payload?.property;

    if (position == null || !property) {
        return state;
    }
    const value = payload?.value;
    const required = payload?.required;
    const page = state.applicationPages[position];

    page[property] = value;
    if (required && !value && !page.errors.requiredError) {
        page.errors.requiredError = true;
    }
    else if (required && value && page.errors.requiredError) {
        page.errors.requiredError = false;
    }
    state.applicationPages[position] = page;
    return state;
};
export const setFieldPropertyForSection = (state, action) => {
    const payload = action.payload;
    const position = payload?.position;
    const property = payload?.property;

    if (position == null || !property) {
        return state;
    }
    const value = payload?.value;
    const section = state.applicationSections[position];

    section[property] = value;
    state.applicationSections[position] = section;
    return state;
};
export const setFieldPropertyForQuestion = (state, action) => {
    const payload = action.payload;
    const position = payload?.position;
    const property = payload?.property;

    if (position == null || !property) {
        return state;
    }
    const value = payload?.value;
    const required = payload?.required;
    const question = state.applicationQuestions[position];

    question[property] = value;

    if (required && !value && !question.errors.requiredError) {
        question.errors.requiredError = true;
    }
    else if (required && value && question.errors.requiredError) {
        question.errors.requiredError = false;
    }
    
    if (property == 'columnWidth') {
        if (value == CONSTANTS.columnWidthOptions.extended) {
            handleExpandQuestion(state, question, position);
        }
        else if (value == CONSTANTS.columnWidthOptions.regular) {
            handleContractQuestion(state, question, position);
        }
    }
    else {
        state.applicationQuestions[position] = question;
    }

    return state;
};